//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Field } from 'vant'

export default {
  name: 'CInput',

  components: { Field },

  inheritAttrs: false,

  props: {
    ...Field.props,
    value: {
      type: [
        String,
        Number,
      ],
      default: '',
    },

    placeholder: { type: String },
  },

  methods: {

    onClear () {
      this.$emit('clear')
    },

    doClear () {
      this.$emit('input', undefined)
    },

  },
}
